import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Home from './pages/Home';
import AdminDashboard from './pages/AdminDashboard';
import DeleteAccount from './pages/DeleteAccount';

// Admin emails allowed to access dashboard
const ADMIN_EMAILS = ['giovanny.pinilla@yahoo.com.co', 'giovannyepinillaa@gmail.com', 'luishsd1978@gmail.com'];

function App() {
  const { isAuthenticated, user } = useAuthStore();
  const isAdmin = user?.role === 'admin' || ADMIN_EMAILS.includes(user?.email || '');

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Layout>
              <Home />
            </Layout>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      
      <Route
        path="/admin"
        element={
          isAuthenticated && isAdmin ? (
            <Layout>
              <AdminDashboard />
            </Layout>
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/delete-account"
        element={
          isAuthenticated ? (
            <DeleteAccount />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}

export default App;
